/* eslint-disable react/display-name */
import React, {useState} from 'react';
import { useParams } from 'react-router-dom';
import { Handle } from 'reactflow';
import { Typography, Tooltip } from '@mui/material';
import { useJourney } from '../../../../../api/Journeys/journey_queries';
import { StepTypeIcon } from '../../../JourneyConstants';
import useLocalStore from '../../../../../useLocalStore';

const HANDLE_STYLE = {
    background: 'transparent',
    border: 0
};

const ExitEditNode = React.memo(({ data }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);

    const { isDisabled, stepId } = data;
    const [ hasTrigger, setHasTrigger ] = useState(false);
    const [ mergeSidebarOpen, setMergeSidebarOpen ] = useState(false);
    const { isFetching, data: journey } = useJourney(journeyId);

    const [setSidebar] = useLocalStore((state) => [state.setSidebar]);

    const handleSidebar = () => {
        const payload = {
            open: true,
            name: 'JourneyDropout',
            params: {
                flowId: journeyId
            }
        };
        setSidebar(payload);
    };

    const onClickOpenMergeSidebar = () => {
        const payload = {
            open: true,
            name: 'JourneyMergeExit',
            params: {
                flowId: journeyId,
                exitStepId: stepId,
                exitStepData: data,
            }
        };
        setSidebar(payload);
    };

    React.useEffect(() => {
        const isTriggerSet = journey && journey?.status === 'draft' && !(journey?.dropout_filter_draft || journey?.dropout_filter);
        setHasTrigger(isTriggerSet);
    }, [journey]);

    const unsetTriggerClass = hasTrigger ? 'highlight' : '';

    return (
        <div style={{margin: 'auto', cursor: 'pointer'}} >
            {/*<Tooltip title='Set Exit Trigger' open={Boolean(hasTrigger)} PopperProps={{ disablePortal: true }} placement='right'>*/}
            {/*    <div className={!isDisabled ? `flow-exit-node ${unsetTriggerClass}` : `flow-exit-node ${unsetTriggerClass} disabled`} onClick={handleSidebar}>*/}
            {/*        <Typography variant='caption' component='div' style={{fontWeight: 500, display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 10}}>*/}
            {/*            <FlagRounded fontSize='small' color='primary' />*/}
            {/*        </Typography>*/}
            {/*    </div>*/}
            {/*</Tooltip>*/}

            {/*<Tooltip title='Merge Exit' open={Boolean(!mergeSidebarOpen)} PopperProps={{disablePortal: true}}*/}
            {/*         placement='right' onClick={onClickOpenMergeSidebar}>*/}
                <div
                    className={!isDisabled ? `flow-exit-node ${unsetTriggerClass}` : `flow-exit-node ${unsetTriggerClass} disabled`}
                    onClick={onClickOpenMergeSidebar}>
                    <div className='node-icon' style={{ marginRight: '4px' }}>
                        <StepTypeIcon step={{ type: 'exit' }} fontSize='small' color='primary' />
                    </div>
                    <Typography variant='caption' component='div' style={{
                        fontWeight: 400,
                        fontSize: 12
                    }}>
                        Exit
                    </Typography>
                </div>
            {/*</Tooltip>*/}


        </div>
    );
});

export default ExitEditNode;
